<template>
	<!-- CARDS -->
	<router-link
		class="aup-base-members-card w-100 px-md-2 px-xl-3 text-decoration-none mb-md-4 mb-lg-0"
		:to="{ name: 'PublicProfile', params: { username: profileUrl}}"
	>
		<div class="bg-white overflow-hidden">
			<div
				class="aup-base-members-card__background"
				:style="{'background-image': `url(${sourceBackdropImage}`}"
			></div>
			<div
				class="d-flex flex-column h-100 w-100 align-items-center justify-content-around" style="padding-bottom: 5%;"
			>
				<div
					class="aup-base-members-card__avatar"
					:style="{'background-image': `url(${sourceAvatar}`}"
				></div>
				<h3
					class="aup-base-members-card__name text-body text-center px-3 t-shadow"
				>error:call:59</h3>
				<div class="aup-base-members-card__arrow-container aup-base-members-card__arrow-container--center">
					<div class="aup-base-members-card__arrow-slider">
						<svg
							class="aup-base-members-card__arrow"
							xmlns="http://www.w3.org/2000/svg"
							width="64"
							height="10"
						>
							<path d="M0 5h56.8" />
							<path d="M55.4 10L64 5l-8.6-5z" />
						</svg>
					</div>
				</div>
			</div>
		</div>
	</router-link>
</template>
<script>
import { PROFILE_CONSTANTS } from "@/PROFILE_CONSTANTS";
export default {
    name: 'BaseMembersCard',
    props: {
        name: {
            type: String,
            default: '',
        },
        avatar: {
            type: String,
            default: '',
        },
        profileLink: {
            default: '',
            type: String,
            required: true,
        },
        backdropImage: {
            required: true,
        },
    },
    method: {},
    data() {
        return {
            profileUrl: this.profileLink ? this.profileLink : '',
        };
    },
    computed: {
        sourceAvatar() {
            if (this.avatar == null || !this.avatar)
                return 'https://alphauniverseglobal.media.zestyio.com/ProfileDisplayPicture_HumanEgg.jpg';
            else return this.avatar;
        },
        sourceProfileLink() {
            if (this.profileLink == null) return 'https://alphauniverse.com';
            else return this.profileLink;
        },
        sourceBackdropImage() {
            if (!this.backdropImage)
                return 'https://alphauniverseglobal.media.zestyio.com/profile-default-cover-mobile.png';
            else return this.backdropImage;
        },
    },
};
</script>

<style lang="scss">
@import '../../assets/scss/all.scss';

.aup-base-members-card {
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    margin-bottom: 24px;

    &:hover {
		transform: translateY(-8px);
		text-decoration: none;
		.aup-base-members-card__name {
			opacity: 1;
		}
		.aup-base-members-card__arrow-container {
			visibility: visible;
		}
		.aup-base-members-card__arrow-slider {
			left: 0;
		}
		.aup-base-members-card__arrow-container--center {
			transform: translateX(0);
		}
    }
    &__avatar-container {
        z-index: 1;
        width: 105px;
        height: 105px;
        transform: translateY(25%);
    }
    &__avatar {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        width: 105px;
		height: 105px;
		margin-top: -52.5px;
        border: 4px solid $white;
        border-radius: 50%;
		position: relative;
		// dl- fallback in case the image 404s:
		background-color: $sony-black;
        @include media-breakpoint-down(md) {
            border: 3px solid $sony-white;
        }
    }
    &__name {
        padding-top: 1rem;
		min-height: 100px;
        z-index: 1;
    }
    &__background {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 50% 50%;
		position: relative;
		height: 17rem;
        &::before {
            content: '';
            display: block;
            position: absolute;
            left: -1px;
            right: 1px;
            top: 0;
            width: 102%;
            height: 100%;
            background: linear-gradient(
                to top,
                rgba(0, 0, 0, 0.15) 75%,
                rgba(0, 0, 0, 0.25) 100%
            );
            transition: background 0.3s ease-in;
        }
        &:hover::before {
            background: linear-gradient(
                to top,
                rgba(0, 0, 0, 0.05) 75%,
                rgba(0, 0, 0, 0.15) 100%
            );
        }
    }
    &__arrow-container {
        position: relative;
        display: inline-block;
        height: 10px;
        width: 64px;
        overflow: hidden;
		padding-bottom: 10%;
		&--center {
			transform: translateX(25%);
			transition: transform 0.3s ease-in-out;
		}
    }
    &__arrow-slider {
        position: absolute;
        left: -32px;
        top: 50%;
        transform: translateY(-50%);
        transition: left 0.3s ease-in-out;
    }
    &__arrow {
        display: block;
        fill: $sony-black;
        stroke-miterlimit: 500;
        path:first-child {
			stroke: $sony-black;
        }
    }
}
</style>
